import React from "react";
import { useNavigate } from "react-router-dom";

import styles from "./style.module.scss";
import MeetUsWrapper from "Components/MeetUsWrapper";
import IconColck from "../../Utils/Assets/Icons/IconColck.png";
import CoinsVideo from "../../Utils/Assets/Images/coins-rotating.webm";
const GetStartedSection = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.container}>
            <MeetUsWrapper>
                <div className={styles.cardBorderWrapper}>
                    <div className={styles.cardBorder}>
                        <div className={styles.cardFlex}>
                            {/* Text */}
                            <div
                                className={styles.flexCol}
                                data-aos="fade-right"
                                data-aos-duration="800"
                                data-aos-once="false"
                            >
                                <div className={styles.flex}>
                                    <img src={IconColck} alt="IconColck" />
                                    <p className="">
                                        Limited-Time Offer: Earn Extra MVR for
                                        Your First Activity!
                                    </p>
                                </div>
                                <div className={styles.subtext}>
                                    <p className="">
                                        Get Started & Earn MVR <br /> Coins Now!
                                    </p>
                                    <div className={styles.buttonRight}>
                                        <button onClick={() => navigate("/download-app")}></button>
                                    </div>
                                </div>
                            </div>

                            <div className="">
                                <video
                                    src={CoinsVideo}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    className={styles.coinsVideo}
                                    data-aos="fade-up"
                                    data-aos-duration="800"
                                ></video>
                            </div>
                        </div>
                    </div>
                </div>
            </MeetUsWrapper>
        </div>
    );
};

export default GetStartedSection;
